var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
var DayMatrixLabel = function (_a) {
    var dayMatrix = _a.dayMatrix, nodeTypeCode = _a.nodeTypeCode;
    // Show day matrix label only for routes and route segments
    if (nodeTypeCode === 'R' || nodeTypeCode === 'S') {
        return _jsxs("span", __assign({ className: 'day-matrix-label' }, { children: [" [M", dayMatrix.days, "]"] }));
    }
    return null;
};
export default DayMatrixLabel;
